// http://s-gateway-ci.k8s.zhihuiya.com/s-analytics-lab-service/lab-service/swagger-ui.html#/
export function makeLabUrl(server) {
    const M = (j) => server + '/lab-service' + j;
    return {
        lab: {
            getAppsPagination: M('/apps/pagination'),
            putAppStaging: M('/apps/app/staging'),
            getDeveloperPagination: M('/apps/developer/pagination'),
            putAppsApp: M('/apps/app'),
        },
    };
}
